export function SortObject(array, sort) {
  return array.sort((a, b) => {
    const order = a[sort.by] > b[sort.by]
    const asc = sort.order === 'asc' ? order : !order
    return asc ? 1 : -1
  })
}
